module.exports = __webpack_public_path__ + "static/media/img_suss_approve.74a195d8.png";